'use strict';

export class ChoiceSelect {
	async multiSelect(multiClass) {
		const multi = document.querySelectorAll(multiClass);

		if ( ! multi || multi.length === 0) {
			return;
		}

		try {
			await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js');
			multi.forEach((select) => {
				if (!select.classList.contains('choices__input')) {
					try {
						const choicesOptions = {
							shouldSortItems: false,
							removeItemButton: true,
							allowHTML: false
						}

						if (select.placeholder) {
							choicesOptions.placeholder = true;
							choicesOptions.placeholderValue = select.placeholder;
						}

						new Choices( select, choicesOptions);
					} catch ( error ) {
						console.error( error.message );
					} finally {
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	async singleSelect() {
		const single = document.querySelectorAll('.single_choices select');
		if ( ! single || single.length === 0) {
			return;
		}

		try {
			await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js');
			single.forEach((select) => {
				if (!select.classList.contains('choices__input')) {
					try {
						const choicesOptions = {
							shouldSortItems: false,
							allowHTML: true,
							callbackOnCreateTemplates: function (template, escapeForTemplate, getClassNames) {
								return {
									item: ({classNames}, data) => {
										return template(`
											<div
												class="${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
												data-item
												data-id="${data.id}"
												data-value="${data.value}"
												${data.active ? 'aria-selected="true"' : ''}
												${data.disabled ? 'aria-disabled="true"' : ''}
											>
												 ${data.label}
											</div>
										`);
									}, choice: ({classNames}, data) => {
										return template(`
											<div
											    class="${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}"
												data-select-text="${this.config.itemSelectText}"
												data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
												data-id="${data.id}"
												data-value="${data.value.replace(/\D/g, '')}"
												data-currency="${data.element.dataset.currency}"
												${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}
												>
												 ${data.label}
											</div>
										`);
									},
								};
							},
						}

						if (select.placeholder) {
							choicesOptions.placeholder = true;
							choicesOptions.placeholderValue = select.placeholder;
						}

						new Choices(select, choicesOptions);
					} catch ( error ) {
						console.error( error.message );
					} finally {
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	async singleInput() {
		const single = document.querySelectorAll('.text_input_choices input');
		if ( ! single || single.length === 0) {
			return;
		}

		try {
			await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js');
			single.forEach((input) => {
				if (!input.classList.contains('choices__input')) {
					try {
						const choicesOptions = {
							shouldSortItems: true,
							editItems: true,
							duplicateItemsAllowed: false,
							removeItemButton: true,
							allowHTML: false
						};
						const wrapper = input.closest('.text_input_choices');

						if (input.placeholder) {
							choicesOptions.placeholder = true;
							choicesOptions.placeholderValue = input.placeholder;
						}

						if (wrapper.classList.contains('numbers_only')) {
							choicesOptions.addItemFilter = (value) => {
								// Allow only numbers
								return /^-?\d+(\.\d+)?$/.test(value);
							};
						}

						new Choices( input, choicesOptions);
					} catch ( error ) {
						console.error( error.message );
					} finally {
					}
				}
			})
		} catch (error) {
			console.error( error.message );
		}
	}

	update() {
		this.multiSelect('.multi_choices.countries select');
		this.multiSelect('.multi_choices.currencies select');
		this.multiSelect('.multi_choices.gateways select');
		this.singleSelect();
		this.singleInput();
	}
}
